import React, { useState } from "react";
import ConfirmMessage from "./ConfirmMessage";
import axios from "../../../configApi/axiosConfig";
import { APIURL } from "../../../configApi/apiConfig";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
export function ModalFirmaElectronica({ data, isOpen, onClose, isExistPrefactura }) {

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [apiMessage, setApiMessage] = useState(null);
  const [apiMessageType, setApiMessageType] = useState(null); // 'success' | 'error'
  const [isSubmitting, setIsSubmitting] = useState(false);

  const confirmMessage = "¿Está seguro que desea generar el link biométrico? Recuerde que el Cliente debe contar con su cédula física.";

  const handleGenerateBiometricLink = () => {
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    setConfirmOpen(false);
    setIsSubmitting(true);
    try {
      const response = await axios.post(APIURL.serviciosia365pro_biometric(), {
        identificacion: data?.cedula,
        callback: "https://backregistrocivil.appservices.com.ec/api/v1/corporacion-dfl/serviciosia365pro/biometrico/callback",
        motivo: data?.nombre,
        cre_solicitud: data?.sCre_SolicitudWeb,
        usuario: data?.usuario || "ECEPEDA"
      });
      setApiMessage(response?.data?.message || "Link biométrico generado correctamente");
      setApiMessageType('success');
    } catch (err) {
      setApiMessage("Error al generar el link biométrico");
      setApiMessageType('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setConfirmOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm px-4 py-6">
      <div className="bg-white rounded-2xl shadow-2xl p-0 w-full max-w-2xl relative animate-fadeIn border border-blue-200 overflow-hidden">
        {/* Encabezado institucional */}
        <div className="flex items-center justify-between px-6 md:px-8 py-5 bg-gradient-to-r from-blue-900 via-blue-800 to-cyan-700">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-white/15 border border-white/25 backdrop-blur-sm flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 7a3 3 0 013-3h10a3 3 0 013 3v10a3 3 0 01-3 3H7a3 3 0 01-3-3V7z" stroke="#fff" strokeWidth="1.6" /><path d="M8 12h8M12 8v8" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" /></svg>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.18em] text-blue-100/90">Proceso único</p>
              <span className="text-lg md:text-xl font-bold text-white tracking-wide">Solicitud de Firma Electrónica</span>
            </div>
          </div>
          <button
            className="text-white/90 hover:text-white text-2xl font-bold w-10 h-10 rounded-lg hover:bg-white/10 transition-colors"
            onClick={onClose}
            title="Cerrar"
          >
            ×
          </button>
        </div>
        {/* Datos del ciudadano */}
        <div className="px-6 md:px-8 py-5 border-b border-slate-200 bg-slate-50">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:items-center">
            <div className="md:col-span-2">
              <p className="text-xs uppercase tracking-[0.14em] text-slate-500">Titular</p>
              <div className="text-lg font-semibold text-slate-800 leading-tight mt-1">{data?.nombre || "-"}</div>
            </div>
            <div className="text-sm md:text-right text-slate-700">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-slate-200 shadow-sm">
                <span className="text-slate-500">Solicitud</span>
                <span className="font-semibold text-slate-800">#{data?.NumeroSolicitud || "-"}</span>
              </div>
            </div>
            <div className="text-sm text-slate-600 md:col-span-3">
              Cédula: <span className="font-semibold text-slate-800">{data?.cedula || "-"}</span>
            </div>
          </div>
        </div>
        {/* Mensaje API (éxito / error) */}
        {apiMessage && (
          <div className={`px-5 py-3 mx-6 md:mx-8 mt-5 rounded-xl flex items-start justify-between gap-4 shadow-sm ${apiMessageType === 'success' ? 'bg-emerald-50 border border-emerald-200 text-emerald-800' : 'bg-rose-50 border border-rose-200 text-rose-800'}`} role="status">
            <div className="flex items-center gap-3">
              <span className="mt-0.5">
                {apiMessageType === 'success' ? '✓' : '!'}
              </span>
              <div className="text-sm leading-tight font-medium">{apiMessage}</div>
            </div>
            <button onClick={() => { setApiMessage(null); setApiMessageType(null); }} className="text-sm font-semibold opacity-80 hover:opacity-100 transition-opacity">Cerrar</button>
          </div>
        )}
        {/* Estado actual de la firma electrónica */}
        <div className="px-6 md:px-8 py-7 md:py-8">
          {isExistPrefactura ? (
            <div className="flex flex-col items-center justify-center text-center gap-3 bg-gradient-to-br from-red-50 to-red-100 border-2 border-red-300 p-4 rounded-xl shadow-md">
              <ReportProblemIcon fontSize="large" className="text-red-600 animate-pulse" />
              <p className="font-bold text-red-800 text-sm">
                No se encontró ninguna <span className="uppercase">pre-factura activa</span>
              </p>
              <span className="text-xs text-red-600">
                Si considera que esto es un error, contacte a soporte.
              </span>
            </div>
          ) : (
            <div className="rounded-2xl border border-blue-100 bg-gradient-to-br from-blue-50 to-cyan-50 p-6 md:p-7">
              <div className="flex flex-wrap items-center gap-3 mb-3">
                <span className="text-xs font-semibold uppercase tracking-[0.16em] text-blue-700">Estado disponible</span>
                <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-white text-blue-800 border border-blue-200">Generar link biométrico</span>
              </div>
              <h3 className="text-lg font-bold text-slate-900">Envío del link biométrico</h3>
              <p className="text-sm text-slate-600 mt-2">
                Esta acción enviará el enlace biométrico al cliente para continuar el proceso de verificación de identidad y firma digital.
              </p>
              <button
                className="mt-5 w-full md:w-auto px-6 py-2.5 rounded-xl font-bold bg-blue-700 text-white shadow-md transition-all duration-200 hover:bg-blue-800 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
                onClick={handleGenerateBiometricLink}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Procesando..." : "Generar link biométrico"}
              </button>
            </div>
          )}
        </div>
        <ConfirmMessage
          isOpen={confirmOpen}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          message={confirmMessage}
        />
      </div>
    </div>
  );
}
